import {createContext} from 'react'

export const ServiceContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  gridRowCount: 0,
  setGridRowCount: () => {
  },
  gridCurrentPage: 1,
  setGridCurrentPage: () => {
  },
  service: {
    id: null,
    agent_id: null,
    person_id: null,
    branch_id: null,
    person_name: "",
    person_family: "",
    agent_name: "",
    agent_family: "",
    field_title: "",
    branch_title: "",
    price: null,
    day: null,
    topic: "",
    challenge: "",
    status: "",

  },
  setService: () => {
  },
  branchInfo: {
    id: null, // branch_id
    branch_title: "",
    agent_branch_fee_id: null,
    agent_branch_id: null,
    price: null,
    consensual: "",
    max_price: null,
    min_price: null,
    side_cost: false,
    side_cost_description: "",
    period: false,
    day: null,
    min_day: null,
    max_day: null
  },
  setBranchInfo: () => {
  },
  document: {
    id: null,
    title: "",
    description: "",
    file: "",
    status: "",
  },
  setDocument: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
  step: "",
  setStep: () => {
  },
  from: "",
  chargeAmount: 0,
  setChargeAmount: () => {
  },
  chargeDiscountCode: "",
  setChargeDiscountCode: () => {
  },
  allAccepted: false,
  setAllAccepted: () => {

  },
  show: 2,
  setShow: () => {
    
  }
})